import axios from 'axios';
import { webToMiniprogram, isDouyinClient, webToApp } from './miniprogram.js'
import { NissanApi } from './nissanApi.js'
import { message } from 'ant-design-vue';
import Cookies from 'js-cookie'
import { isInApp, getSystemInfo } from './brower';
import sha512 from 'js-sha512';
import Vue from 'vue'
import Rebot from '@/components/Rebot.vue'
import MRebot from '@/components/MRebot.vue'
const { lyRebotDomain } = GLOBAL_VARS;
export const $isPC = function () {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
const isMobilePhone = function () {
    if (window.__wxjs_environment === 'miniprogram') {
        return true
    }
    const ua = navigator.userAgent.toLowerCase();
    const t1 = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua);
    return t1
};
export const getQueryString = function (name, str) {
    let url = unescape(str ? str : location.href);
    let end = url.split("#")[0].substring(url.split("#")[0].length - 1, url.split("#")[0].length);
    if (end == "=") {
        url = url.split("#")[0].substring(0, url.split("#")[0].length - 1);
    }
    return (
        unescape(
            (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                unescape(url)
            ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
    );
};
const getCurrentUrl = function () {
    let newQuery = '';
    if (location.search) {
        const obj = {};
        decodeURIComponent(location.search).split('?')[1].split('&').forEach(item => {
            const key = item.split('=')[0];
            const value = decodeURIComponent(item.split('=')[1]);
            obj[key] = value;
        })
        newQuery = Object.assign(newQuery, obj);
    }
    if (location.hash && location.hash.indexOf('?') != -1) {
        const obj = {};
        decodeURIComponent(location.hash).split('?')[1].split('&').forEach(item => {
            const key = item.split('=')[0];
            const value = decodeURIComponent(item.split('=')[1]);
            obj[key] = value;
        })
        newQuery = Object.assign(newQuery, obj);
    }
    return newQuery;
}
const BOOK_CAR_DOMAIN = {
    prod: {
        app: {
            nissan_app: {
                1: '/oneapp/xTrailSmallOrder',
                2: '/oneapp/chooseCollocation',
                path: 'https://oneapph5.dongfeng-nissan.com.cn',
            },
            venucia_app: {
                1: '',
                2: '',
                path: 'https://v2h5vit.venucia.com/onlinebuycarnew/home',
            },
        },
        wx_iniprogram: {
            path: '/package_car/pages/book_car/index',
            1: '',
            2: ''
        }
    },
    other: {
        app: {
            nissan_app: {
                1: '/oneapp/xTrailSmallOrder',
                2: '/oneapp/chooseCollocation',
                path: 'https://h5uatn.venucia.com',
            },
            venucia_app: {
                1: '',
                2: '',
                path: 'https://v2h5zh.venucia.com/onlinebuycarnew/home',
            },
        },
        wx_iniprogram: {
            path: '/package_car/pages/book_car/index',
            1: '',
            2: ''
        }
    },
}
/**
 * @description: 下定
 * @param {*} query
 * @return {*}
 */
export const payment = async function (query) {
    const { terminal_type, source, carBaseSeriesCode, mp = '' } = query;
    console.log('carBaseSeriesCode', carBaseSeriesCode)
    const { data: { extrInfo, carBrandId } } = await axios.post(getBasePath() + GLOBAL_VARS.dongfengApi.listInStockBaseCarSeries, { baseSeriesCode: carBaseSeriesCode });//extrInfo 1为小定，2为大定
    const env = GLOBAL_VARS.BASE_ENV == 'prod' ? 'prod' : 'other'
    console.log('extrInfo', extrInfo)
    if (extrInfo == 0) {
        return
    }
    if (terminal_type && terminal_type.indexOf('app') != -1 || source && source.indexOf('app') != -1) {
        let data = BOOK_CAR_DOMAIN[env]['app'][mp];
        let url = `${data.path}${data[extrInfo]}?carBrandCode=${carBrandId}&carBaseSeriesCode=${carBaseSeriesCode}`
        if (mp == 'venucia_app') {
            window.location.href = `${data.path}${data[extrInfo]}?carBaseSeriesCode=${carBaseSeriesCode}`
            return
        }
        const appRoute = {
            jump_type: 'web_by_url',
            jump_info: {
                url: url,
            },
        };
        webToApp(appRoute);
        return;
    }
    else {
        let newQuery = getCurrentUrl();
        let url = `${BOOK_CAR_DOMAIN[env]['wx_iniprogram'].path}`
        webToMiniprogram({
            url: `${url}?carBaseSeriesCode=${carBaseSeriesCode}&bussType=0${extrInfo}&carBrandCode=${carBrandId}`,
        });
    }
}
export function IsNissan() {
    return window.location.href.indexOf('dongfeng-nissan.com') != -1 || window.location.href.indexOf('node-site.nissan-website') != -1
}
const bases = [
    {
        url: 'node-site.nissan-website.dev.dndc.cloud/venucia-3d/node-configurator',
        base: 'venucia-3d/node-configurator'
    },
    {
        url: 'dndcfenge-node-configurator.venucia-3d.dev.dndc.cloud',
        base: ''
    },
    {
        url: 'dongfeng-nissan.com.cn/venucia-3d/node-configurator',
        base: 'venucia-3d/node-configurator'
    },
    {
        url: 'activity.venucia.com/ext/venucia-3d/node-configurator',
        base: 'ext/venucia-3d/node-configurator'
    },
]
export const getBase = () => {
    if (location.pathname.indexOf('/home') != -1) {
        return location.pathname.slice(1, location.pathname.indexOf('/home'))
    }
    return location.pathname.slice(1, location.pathname.indexOf('/car/'))
}
export function getBasePath() {
    let base = getBase()
    return location.href.indexOf('configurator.venucia-3d.dev.dndc.cloud') != -1 || GLOBAL_VARS.BASE_ENV == 'local' ? `${location.origin}/` : `${location.origin}/${base ? base + '/' : ''}`
}
export async function loadFont(fontName, fontUrl) {
    const font = new FontFace(fontName, `url(${fontUrl})`)
    await font.load()
    document.fonts.add(font)
}
// 经纬度转换成三角函数中度分表形式。
function rad(d) {
    return d * Math.PI / 180.0;
}


// 根据经纬度计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
export function getDistance(lat1, lng1, lat2, lng2) {

    var radLat1 = rad(lat1);
    var radLat2 = rad(lat2);
    var a = radLat1 - radLat2;
    var b = rad(lng1) - rad(lng2);
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
    s = s * 6378.137; // EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000; //输出为公里

    var distance = s;
    var distance_str = "";

    if (parseInt(distance) >= 1) {
        distance_str = distance.toFixed(1) + "km";
    } else {
        distance_str = distance * 1000 + "m";
    }

    //s=s.toFixed(4);

    console.info('lyj 距离是', s);
    console.info('lyj 距离是', distance_str);
    return s;
}

export async function getLocation() {
    if ((isInApp())) {
        const res = await getOneAppLocation()
        if (typeof (res) == 'object') {
            return res
        }
    }
    if (
        getQueryString("terminal_type") &&
        getQueryString("terminal_type").indexOf("tt") != -1
    ) {
        const res = await axios.get('https://digital-official-api.dongfeng-nissan.com.cn/nissan/api/ip-location')
        const { location: { latitude, longitude } } = res.data;
        return { latitude, longitude };
    }
    else {
        const getCurrentPosition = () => new Promise(resolve => {
            getAMapLocation((data) => {
                resolve({ latitude: data.lat, longitude: data.lng })
            })
        })
        const res = await getCurrentPosition()
        // const geolocation = new BMap.Geolocation();
        // const getCurrentPosition = () => new Promise(resolve => {
        //     geolocation.getCurrentPosition(res => {
        //         console.log("this.address", res);
        //         resolve(res)
        //     });
        // })
        // const res = await getCurrentPosition()
        return res;
    }
}
export async function getAMapLocation(callback) {
    try {
        debugger
        AMap.plugin('AMap.Geolocation', function () {
            const geolocation = new AMap.Geolocation({
                enableHighAccuracy: true, // 是否使用高精度定位，默认:true
                timeout: 5000, // 超过10秒后停止定位，默认：5s
                position: 'RB', // 定位按钮的停靠位置
                offset: [10, 20], // 定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
                zoomToAccuracy: true, // 定位成功后是否自动调整地图视野到定位点
            });
            geolocation.getCurrentPosition(async function (status, result) {
                const { position, message, originMessage } = result;

                if (status === 'complete') {
                    const BMapPosition = AMapTransBMap(position.lng, position.lat);
                    debugger
                    callback({
                        lat: BMapPosition.lat,
                        lng: BMapPosition.lng,
                    });
                } else {
                    const resPositionByIP = await getLocationByIP();
                    callback(resPositionByIP);
                    console.log(
                        `AMap Location Error:${message}</br>浏览器返回信息：${originMessage}`,
                    );
                }
            });
        });
    } catch (error) {
        console.log('AMap Location Error:', error);
        (async () => {
            await getLocationByIP().then((data) => {
                callback(data);
            });
        })();
    }
}
async function getLocationByIP() {
    const res = await axios.get('https://digital-official-api.dongfeng-nissan.com.cn/nissan/api/ip-location')
    const { location: { latitude, longitude } } = res.data;
    return { lat: latitude, lng: longitude };
}

/**
 * 将腾讯/高德地图经纬度转换为百度地图经纬度
 * @param {number} lng lng
 * @param {number} lat lat
 * @return {Object}
 */
export function AMapTransBMap(lng, lat) {
    const x_pi = (3.14159265358979324 * 3000.0) / 180.0;
    const x = lng;
    const y = lat;
    const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
    const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
    const lngs = z * Math.cos(theta) + 0.0065;
    const lats = z * Math.sin(theta) + 0.006;

    return {
        lng: lngs,
        lat: lats,
    };
}
export const getOneAppLocation = () => {
    if (isInApp()) {
        if (getQueryString('mp') == 'venucia_app') {
            return new Promise((resolve) => {
                const systemInfo = getSystemInfo();
                if (systemInfo.ios) {
                    window.webkit.messageHandlers.getLocationInfo.postMessage('');
                } else if (systemInfo.android) {
                    window.webkit.getLocationInfo();
                }
                // 启辰APP-bug， getLocationData会触发多次
                window.getLocationData = function (Info) {
                    try {
                        if (systemInfo.ios) {
                            if (Info.city) resolve(Info);
                        } else if (systemInfo.android) {
                            const resData = JSON.parse(Info);
                            console.log('启辰app位置:', Info)
                            if (resData.city) resolve(resData);
                        }
                    }
                    catch (error) {
                        resolve('error')
                    }
                };
            });
        }
        const systemInfo = getSystemInfo();
        return new Promise((resolve) => {
            window.getLocationInfoResult = (res) => {
                if (typeof (res) == 'string') {
                    console.log('appLocation:', res)
                    resolve(JSON.parse(res));
                } else {
                    resolve(res);
                }
            };
            try {
                if (systemInfo.ios) {
                    window.webkit.messageHandlers.getLocationInfoV2.postMessage({
                        '': '',
                    });
                } else if (systemInfo.android) {
                    window.webkit.getLocationInfoV2();
                } else {
                    resolve();
                }
            } catch (e) {
                console.log('getOneAppLocation error', e);
                resolve('error');
            }
        });
    }
    return new Promise((resolve) => {
        resolve();
    });
};

export const getUserPhone = function () {
    return new Promise(resolve => {
        const mp = getQueryString('mp')
        if (mp == 'nissan_app' || mp == 'venucia_app') {
            NissanApi.getAppUserInfo(info => {
                resolve(info.data.phoneNum ?? info.data.phone)
            })
        }
        else {
            resolve(getQueryString('phone'))
        }
    })
}

export async function finishTask() {
    const activityCode = getQueryString('activityCode')
    const appCode = getQueryString('appCode')
    const activityId = getQueryString('activityId')
    const oneid = getQueryString('oneid')
    const actToken = getQueryString('actToken')
    const taskId = getQueryString('taskId')
    const path = GLOBAL_VARS.BASE_ENV == 'prod' ? appCode == 'nissan' ? 'https://oneapph5.dongfeng-nissan.com.cn/mb-gw/' : 'https://oneapph5.dongfeng-nissan.com.cn/venucia-gw/' : 'https://ariya-api-sit.dongfeng-nissan.com.cn/'
    const url = path + 'dfn-activity/rest/ly-mp-iov-activity-service/vmsp/drivecharacter/finish/task'
    await axios.post(url, {
        actToken,
        taskId,
        oneid,
        appCode,
        activityCode,
        activityId
    })
    message.success('恭喜您已完成浏览车辆3D看车页任务');
}

export async function saveConfig(carStates) {
    const { carName, version, carType, innerColor, innerColorcode, outColor, outColorcode, assembles, options, source_page } = carStates;
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
    };
    const { data: { rows: logid } } = await axios.post(`${GLOBAL_VARS.BASE_ENV == 'prod' ? 'https://digital-official-api.venucia.com/' : 'https://ariya-api-uat.dongfeng-nissan.com.cn/'}venucia-toc-service/api-direct/user/user-config-data`, { configData: { carName, version, carType, innerColor, innerColorcode, outColor, outColorcode, assembles, options } }, config);
    const url = location.href.split('?')[0]
    window.location.href = GLOBAL_VARS.BASE_ENV == 'prod' ? `https://www.venucia.com/v2/PersonalCenter/login?idenType=2&redirect_url=${url}&logid=${logid}&source_page=${source_page}` : `https://www-uat.venucia.com/v2/PersonalCenter/login?idenType=2&redirect_url=${url}&logid=${logid}&source_page=${source_page}`
}

export async function getConfig(logid, saveFun) {
    history.replaceState({}, '', removeParamFromUrl(location.href, 'logid'))
    // location.href = removeParamFromUrl(location.href,'logid')
    if (!logid) {
        return
    }
    const url = `${GLOBAL_VARS.BASE_ENV == 'prod' ? 'https://digital-official-api.venucia.com/' : 'https://ariya-api-uat.dongfeng-nissan.com.cn/'}venucia-toc-service/api-direct/user/get-config-data/${logid}`
    const { data: { rows } } = await axios.get(url);
    let carStates = JSON.parse(rows)
    const { carName, version, carType, innerColor, innerColorcode, outColor, outColorcode, assembles, options } = carStates;
    saveFun({ carName, version, carType, innerColor, innerColorcode, outColor, outColorcode, assembles, options })
}

export async function isUser() {
    let b = false;
    console.log('getQueryString("unionid")', getQueryString("unionid"))
    if (getQueryString("unionid") != undefined) {
        Cookies.set('unionId', getQueryString("unionid"), { expires: 7 });
        Cookies.remove('userid');
        b = true;
    }
    else if (getQueryString("userid") != undefined) {
        Cookies.set('userid', getQueryString("userid"), { expires: 7 });
        Cookies.remove('unionId');
        b = true;
    }
    if (Cookies.get('unionId') || Cookies.get('userid')) {
        const unionId = Cookies.get('unionId') ?? ''
        const id = Cookies.get('userid') ?? ''
        const url = `${GLOBAL_VARS.BASE_ENV == 'prod' ? 'https://digital-official-api.venucia.com/' : 'https://ariya-api-uat.dongfeng-nissan.com.cn/'}venucia-toc-service/api-direct/user/user-info`
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };
        try {
            const { data: { rows: { token = null } } } = await axios.post(url, { unionId, mobile: '', id }, config);
            b = token != null;
        }
        catch (error) {
            console.log(error)
        }
    }
    // location.href = removeParamFromUrl(location.href,'userid')
    history.replaceState({}, '', removeParamFromUrl(location.href, 'userid'))
    history.replaceState({}, '', removeParamFromUrl(location.href, 'unionid'))
    return b;
}

export function removeParamFromUrl(url, ref) //删除参数值
{
    var str = "";

    if (url.indexOf('?') != -1)
        str = url.substr(url.indexOf('?') + 1);
    else
        return url;
    var arr = "";
    var returnurl = "";
    var setparam = "";
    if (str.indexOf('&') != -1) {
        arr = str.split('&');
        for (var i in arr) {
            if (arr[i].split('=')[0] != ref) {
                returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&";
            }
        }
        return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1);
    }
    else {
        arr = str.split('=');
        if (arr[0] == ref)
            return url.substr(0, url.indexOf('?'));
        else
            return url;
    }
}
const createSign = (options) => {
    let { header } = options;
    // const { data = {} } = options;
    // method = method.toUpperCase();
    const e3sConfig = {
        baseHeader: {
            clientid: 'venuciaminiapp', // e3s公共参数
            appcode: 'venucia', //品牌
            'From-Type': 3, //渠道
        },
        tokenName: 'e3s-token',
        userIdName: 'ly_user_id',

    };
    const { baseHeader, tokenName } = e3sConfig;
    const token = '';
    const uuid = '';
    const timestamp = new Date().getTime();
    const noncestr = createNonce().replace(/-/g, '');
    // const range = method === 'POST' ? 2 : 1;
    // const sign = method === 'POST'
    //   ? sha512(clientid + timestamp + token + noncestr + range + uuid + JSON.stringify(data))
    //   : sha512(clientid + timestamp + token + noncestr + range + uuid);
    const range = 1;
    const sign = sha512(baseHeader.clientid + timestamp + token + noncestr + range + uuid);
    header = {
        clientid: baseHeader.clientid,
        timestamp,
        token,
        uuid,
        noncestr,
        range,
        sign,
        'Content-Type': 'application/json',
        ...header,
    };
    return header;
};
const createNonce = () => {
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    console.log('uuid');
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';
  
    const uuid = s.join('');
    return uuid;
  };
export function findInStockAll(env,car,blackCall) {
    const eUrl = 'https://feat-sit-dndcfenge-node-configurator.venucia-3d.dev.dndc.cloud/venucia-gw/bookcaronline/iov/loveCar/personalizationSeting/findInStockAll';
    const pUrl = 'https://activity.venucia.com/ext/venucia-3d/node-configurator/venucia-gw/bookcaronline/iov/loveCar/personalizationSeting/findInStockAll'
    axios.post(env==='prod'?pUrl:eUrl, {carBaseSeriesCode: car==='big-v-ddi'?"11D1":'10X1'}, {
        headers: createSign({})
    }).then((response) => {
        console.log('Response:', response.data);
        blackCall(response.data)
    })
}
export default isMobilePhone;

let rebotInstance = null
function getLYRebot(data) {
    return axios.request(`${lyRebotDomain}/ly/busicenapp/cip/xapi/aiCommonController/getAiUrlMerge`, {
        method: 'POST',
        disableXFeat: true,
        data,
    });
}
export async function openRebot(options = {}) {
    const res = await getLYRebot({
        aiParam: {
            param: {
                brandType: 1, // 业务类型，1:尼桑  2:启辰
                channelName: '日产官网一在线看车',
                channelType: 'venucia_web',
                custome: window.location.href.indexOf('VX6')!=-1?'venucia_vrkc_vx6':'venucia_vrkc_dv',
                platform: 'web', // 写死
                webUnionid:'zxkc'+new Date().getTime()
            },
            pageName: 'nissan_web',
        },
    })
    const {
        result,
        msg,
        rows: { enable, url: targetUrl },
    } = res.data;
    if (+result !== 1) {
        message.error(msg);
        return undefined;
    }
    if (!enable) {
        $isPC()&&AICCFunc.showChatDialog({
            showOrHide: "show"
        });
        // message.error('当前客服未开启');
        return false;
    }
    // if (!$isPC() && targetUrl) {
    //     window.location.href = targetUrl;
    //     return
    // }
    if (rebotInstance) return true

    const container = document.createElement('div')
    document.body.appendChild(container)

    rebotInstance = new Vue({
        render(h) {
            return h(!$isPC()?MRebot:Rebot, {
                props: {
                    title: '在线客服',
                    loading: false,
                    onClose: closeRebot,
                    url:targetUrl
                }
            })
        }
    }).$mount(container)
    return true
}

export function closeRebot() {
    if (!rebotInstance) return
    rebotInstance.$destroy()
    document.body.removeChild(rebotInstance.$el)
    rebotInstance = null
}

window.showChatDialog = openRebot;